export default __webpack_public_path__ + "static/media/account.94da1da6.jpg";